<template>
  <svg class="sprint-def" width="220" height="365" viewBox="0 0 201.86 334.23"  xmlns="http://www.w3.org/2000/svg">
    <defs>

      <linearGradient id="Nepojmenovaný_přechod_82" x1="956.36" y1="417.15" x2="956.36" y2="380.99" gradientTransform="translate(557.29 1355.43) rotate(-90)" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#fff" stop-opacity="0"></stop><stop offset="0.08" stop-color="#fff" stop-opacity="0.03"></stop><stop offset="1" stop-color="#fff" stop-opacity="0.4"></stop></linearGradient></defs><rect class="cls-1" x="1" y="1" width="199.86" height="332.23" rx="16"></rect>

      <path class="cls-2" d="M1040.29,380a15,15,0,0,1,15,15V695.23a15,15,0,0,1-15,15H872.43a15,15,0,0,1-15-15V395a15,15,0,0,1,15-15h167.86m0-2H872.43a17,17,0,0,0-17,17V695.23a17,17,0,0,0,17,17h167.86a17,17,0,0,0,17-17V395a17,17,0,0,0-17-17Z" transform="translate(-855.43 -377.99)"></path>

      <path d="M17,2H184.86a15,15,0,0,1,15,15V40.16a0,0,0,0,1,0,0H2a0,0,0,0,1,0,0V17A15,15,0,0,1,17,2Z"></path>

      <!-- backrest -->
      <g class="clickable" data-action="backrest_adjustment" data-direction="up">
        <path class="cls-3" d="M920.2,454.42a1.73,1.73,0,0,0,1.24-2.89l-9.31-10.79h0a1.64,1.64,0,0,0-2.56,0l-9.26,10.79a1.69,1.69,0,0,0,1.19,2.89Z" transform="translate(-855.43 -377.99)"></path>
      </g>
      <g class="clickable" data-action="backrest_adjustment" data-direction="down">
        <path class="cls-3" d="M920.2,488.48a1.73,1.73,0,0,1,1.24,2.89l-9.31,10.79h0a1.65,1.65,0,0,1-2.56,0l-9.26-10.79a1.69,1.69,0,0,1,1.19-2.89Z" transform="translate(-855.43 -377.99)"></path>
      </g>

      <g>
        <text style="white-space:pre; text-transform: uppercase" x="18" y="25" fill="#fff" font-family="GT America" font-size="9px" font-weight="700" letter-spacing="0.5px">
          {{ recentAction }}
        </text>
      </g>

      <!-- bed height -->
      <g class="clickable" data-action="bed_height_adjustment_up">
        <path class="cls-3" d="M1013.28,454.42a1.73,1.73,0,0,0,1.24-2.89l-9.31-10.79h0a1.64,1.64,0,0,0-2.56,0l-9.26,10.79a1.69,1.69,0,0,0,1.19,2.89Z" transform="translate(-855.43 -377.99)"></path>
      </g>
      <g class="clickable" data-action="bed_height_adjustment_down">
        <path class="cls-3" d="M994.58,488.48a1.73,1.73,0,0,0-1.25,2.89l9.32,10.79h0a1.66,1.66,0,0,0,2.57,0l9.25-10.79a1.69,1.69,0,0,0-1.18-2.89Z" transform="translate(-855.43 -377.99)"></path>
      </g>

      <!-- trendelenburg -->
      <g class="clickable" data-action="trendelenburg">
        <path class="cls-3" d="M1013.31,542.39a1.74,1.74,0,0,1,1.25,2.9l-9.32,10.79h0a1.65,1.65,0,0,1-2.57,0l-9.25-10.79a1.7,1.7,0,0,1,1.18-2.9Z" transform="translate(-855.43 -377.99)"></path>
      </g>
      <g class="clickable" data-action="reverse_trendelenburg">
        <path class="cls-3" d="M901.65,542.39a1.74,1.74,0,0,0-1.25,2.9l9.32,10.79h0a1.65,1.65,0,0,0,2.57,0l9.25-10.79a1.7,1.7,0,0,0-1.18-2.9Z" transform="translate(-855.43 -377.99)"></path>
      </g>

      <path class="cls-4" d="M998.72,567.78a2.2,2.2,0,0,0-.76-.51l-15-5.65.46-3.77a1,1,0,0,0-2-.56l-1.93,4.79a1.71,1.71,0,0,0,1,2.19l22.95,9.31c.31.15.56-.26.36-.51Z" transform="translate(-855.43 -377.99)"></path>

      <path class="cls-4" d="M1017.24,575l-8.55-3.46-5.34-5.7a1.69,1.69,0,0,0-2.39-.1,1.76,1.76,0,0,0-.11,2.44l5.91,6.32a5.31,5.31,0,0,0,2.14,1.32h.05l6.87,2.8a1.94,1.94,0,0,0,1.42-3.62Z" transform="translate(-855.43 -377.99)"></path>

      <path class="cls-4" d="M1022.9,574.84a3.38,3.38,0,1,0,3.37,3.37A3.37,3.37,0,0,0,1022.9,574.84Z" transform="translate(-855.43 -377.99)"></path>

      <path class="cls-4" d="M904.91,476.55l6.18-2.65a3.13,3.13,0,0,1,.92-.16l16.16.5,1-4a1,1,0,0,1,2.07.27v5.16a1.73,1.73,0,0,1-1.73,1.72l-22.55,0a8.72,8.72,0,0,1-2.33-.33C904.27,477,904.6,476.72,904.91,476.55Z" transform="translate(-855.43 -377.99)"></path>

      <path class="cls-4" d="M893.14,467.49l8.4,4.84,6.55-5.14a1.87,1.87,0,0,1,2.6.31,1.81,1.81,0,0,1-.42,2.5l-6.61,5.17a4.57,4.57,0,0,1-4.77.09l-7.67-4.37a2,2,0,0,1,1.92-3.4Z" transform="translate(-855.43 -377.99)"></path>

      <path class="cls-4" d="M887.09,461.69a3.39,3.39,0,1,1-3.39,3.38A3.38,3.38,0,0,1,887.09,461.69Z" transform="translate(-855.43 -377.99)"></path>

      <!-- calfrest -->

      <g class="clickable" data-action="calfrest_adjustment" data-direction="up">
        <path class="cls-3" d="M1013.37,633.46a1.73,1.73,0,0,0,1.25-2.89l-9.32-10.79h0a1.65,1.65,0,0,0-2.57,0l-9.25,10.79a1.69,1.69,0,0,0,1.18,2.89Z" transform="translate(-855.43 -377.99)"></path>
      </g>

      <g class="clickable" data-action="calfrest_adjustment" data-direction="down">
        <path class="cls-3" d="M1013.37,667.52a1.73,1.73,0,0,1,1.25,2.89l-9.32,10.79h0a1.65,1.65,0,0,1-2.57,0l-9.25-10.79a1.69,1.69,0,0,1,1.18-2.89Z" transform="translate(-855.43 -377.99)"></path>
      </g>

      <path class="cls-4" d="M985.9,651.7a3.42,3.42,0,0,1-2.37,4.15,3.39,3.39,0,0,1-1.75-6.54,3.34,3.34,0,0,1,4.12,2.39" transform="translate(-855.43 -377.99)"></path>

      <path class="cls-4" d="M997.81,651.75l5.78-5.83a1.7,1.7,0,1,1,2.39,2.42l-5.8,5.86c-1.26,1.27-2,1.46-3.84,1.46H989a2,2,0,0,1,0-3.91Z" transform="translate(-855.43 -377.99)"></path>

      <path class="cls-5" d="M952.29,301.14h22.16a0,0,0,0,1,0,0V497a0,0,0,0,1,0,0H952.29a14,14,0,0,1-14-14V315.14A14,14,0,0,1,952.29,301.14Z" transform="translate(500 -935.29) rotate(90)"></path>

      <path class="cls-4" d="M1014.07,644.79H1023l1-3.71a1,1,0,0,1,2,.25l0,4.78a1.76,1.76,0,0,1-1.69,1.74l-10.74.35-5,5.09a7.75,7.75,0,0,1-5.83,2.37h-1.26a.31.31,0,0,1-.19-.52l8.56-8.67a4.92,4.92,0,0,1,4.28-1.68" transform="translate(-855.43 -377.99)"></path>

      <!-- legrest -->

      <g class="clickable" data-action="leg_adjustment" data-direction="up">
        <path class="cls-3" d="M920.23,633.46a1.73,1.73,0,0,0,1.25-2.89l-9.32-10.79h0a1.65,1.65,0,0,0-2.57,0l-9.25,10.79a1.69,1.69,0,0,0,1.19,2.89Z" transform="translate(-855.43 -377.99)"></path>
      </g>

      <g class="clickable" data-action="leg_adjustment" data-direction="down">
        <path class="cls-3" d="M920.23,667.52a1.73,1.73,0,0,1,1.25,2.89l-9.32,10.79h0a1.65,1.65,0,0,1-2.57,0l-9.25-10.79a1.69,1.69,0,0,1,1.19-2.89Z" transform="translate(-855.43 -377.99)"></path>
      </g>

      <path class="cls-4" d="M934.42,649.2l-2.78,4.35a1.72,1.72,0,0,1-2.34.49l-9-5.74h0l-3.65-1.81c.14-.14.27-.26.41-.38a5.2,5.2,0,0,1,2.14-1.16,4.55,4.55,0,0,1,3.37.63l3.72,2.44,3.74,2.46,2.81-2.59A1,1,0,0,1,934.42,649.2Z" transform="translate(-855.43 -377.99)"></path>

      <path class="cls-4" d="M892.86,651.7a3.37,3.37,0,1,1-4.11-2.39,3.33,3.33,0,0,1,4.11,2.39" transform="translate(-855.43 -377.99)"></path>

      <path class="cls-4" d="M904.77,651.75l5.78-5.83a1.7,1.7,0,1,1,2.4,2.42l-5.81,5.86c-1.25,1.27-2,1.46-3.84,1.46H896a2,2,0,0,1,0-3.91Z" transform="translate(-855.43 -377.99)"></path>

      <path class="cls-4" d="M926.29,648l-5.88.2-.09.09-5,5a7.76,7.76,0,0,1-5.83,2.36h-1.25a.3.3,0,0,1-.19-.52l8.55-8.66c.14-.14.27-.26.41-.38a4.26,4.26,0,0,1,2.14-1.16,4.55,4.55,0,0,1,3.37.63Z" transform="translate(-855.43 -377.99)"></path>

      <path class="cls-4" d="M1007.93,470.64l16.27.38.87-3.74a1.05,1.05,0,0,1,2.09.25v5.21a1.66,1.66,0,0,1-1.67,1.71l-25,0a.32.32,0,0,1-.15-.61l6.68-3.05a2.69,2.69,0,0,1,.89-.17" transform="translate(-855.43 -377.99)"></path>

      <path class="cls-4" d="M997,473.92a5.36,5.36,0,0,1-2.49.3h0l-7.49.12a2,2,0,0,1-2-1.91,1.84,1.84,0,0,1,1.89-1.91h9.41l7-3.36a1.81,1.81,0,0,1,2.33.84,1.65,1.65,0,0,1-.77,2.24Z" transform="translate(-855.43 -377.99)"></path>

      <path class="cls-4" d="M977,471.45a3.37,3.37,0,1,0,3.37-3.37A3.37,3.37,0,0,0,977,471.45Z" transform="translate(-855.43 -377.99)"></path>

      <path class="cls-4" d="M908.24,571.42a2.2,2.2,0,0,0-.9.16l-14.73,6.36-2.28-3a1,1,0,0,0-1.82,1l1.93,4.79a1.72,1.72,0,0,0,2.22.9l23-9.24c.32-.11.22-.57-.1-.62Z" transform="translate(-855.43 -377.99)"></path>

      <path class="cls-4" d="M926.55,563.71,918,567.16l-7.81-.39a1.69,1.69,0,0,0-1.79,1.59,1.76,1.76,0,0,0,1.62,1.83l8.64.43a5.16,5.16,0,0,0,2.45-.53l0,0L928,567.3a1.94,1.94,0,0,0-1.49-3.59Z" transform="translate(-855.43 -377.99)"></path>

      <path class="cls-4" d="M930.53,559.7a3.37,3.37,0,1,0,4.78.08A3.38,3.38,0,0,0,930.53,559.7Z" transform="translate(-855.43 -377.99)"></path>

  </svg>
</template>

<script>
export default {
  props: {
    recentAction: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
svg {
  width: 202px !important;
  .cls-1{fill:#ccc;}
  .cls-2{fill:#eee;}
  .cls-3{fill:#fff100;stroke:#54565a;stroke-miterlimit:10;stroke-width:1.5px;transition: 0.25s;}
  .cls-4{fill:#54565a;fill-rule:evenodd;}.cls-5{fill:url(#Nepojmenovaný_přechod_82);}

  .clickable {
    &:hover {
      .cls-3 {
        fill: #ED2224;
      }
    }
  }
}
</style>
